// Decoders
import { string } from 'fc-decoders'

// Exports
export default function (category) {
  return string((category && category.name) || category) || ''
}
